type Newsletters = {
  [key: string]: {
    displayName: string;
    value: string;
  };
};

export const NEWSLETTERS: Newsletters = {
  allergiesAsthma: {
    displayName: 'Allergies & Asthma',
    value: 'allergiesAsthma',
  },
  alzheimers: {
    displayName: "Alzheimer's",
    value: 'alzheimers',
  },
  arthritis: {
    displayName: 'Arthritis',
    value: 'arthritis',
  },
  betterSleep: {
    displayName: 'Better Sleep',
    value: 'betterSleep',
  },
  breastCancer: {
    displayName: 'Breast Cancer',
    value: 'breastCancer',
  },
  cancer: {
    displayName: 'Cancer',
    value: 'cancer',
  },
  cholesterolManagement: {
    displayName: 'Cholesterol Management',
    value: 'cholesterolManagement',
  },
  chronicPain: {
    displayName: 'Chronic Pain',
    value: 'chronicPain',
  },
  copd: {
    displayName: 'COPD',
    value: 'copd',
  },
  crohnsUlcerativeColitis: {
    displayName: "Crohn's & Ulcerative Colitis",
    value: 'crohnsUlcerativeColitis',
  },
  coronavirusUpdate: {
    displayName: 'Coronavirus Update',
    value: 'coronavirusUpdate',
  },
  depression: {
    displayName: 'Depression',
    value: 'depression',
  },
  diabetes: {
    displayName: 'Diabetes',
    value: 'diabetes',
  },
  digestiveHealth: {
    displayName: 'Digestive Health',
    value: 'digestiveHealth',
  },
  eczema: {
    displayName: 'Eczema',
    value: 'eczema',
  },
  emotionalWellness: {
    displayName: 'Emotional Wellness',
    value: 'emotionalWellness',
  },
  eyeHealth: {
    displayName: 'Eye Health',
    value: 'eyeHealth',
  },
  fibromyalgia: {
    displayName: 'Fibromyalgia',
    value: 'fibromyalgia',
  },
  foodFitness: {
    displayName: 'Food & Fitness',
    value: 'foodFitness',
  },
  goodHealth: {
    displayName: 'Good Health',
    value: 'goodHealth',
  },
  healthyBones: {
    displayName: 'Healthy Bones',
    value: 'healthyBones',
  },
  healthyCats: {
    displayName: 'Healthy Cats',
    value: 'healthyCats',
  },
  healthyDogs: {
    displayName: 'Healthy Dogs',
    value: 'healthyDogs',
  },
  heartHealth: {
    displayName: 'Heart Health',
    value: 'heartHealth',
  },
  hypertension: {
    displayName: 'Hypertension',
    value: 'hypertension',
  },
  lupus: {
    displayName: 'Lupus',
    value: 'lupus',
  },
  migraine: {
    displayName: 'Migraine',
    value: 'migraine',
  },
  mensHealth: {
    displayName: "Men's Health",
    value: 'mensHealth',
  },
  multipleSclerosis: {
    displayName: 'Multiple Sclerosis',
    value: 'multipleSclerosis',
  },
  parentingChildrensHealth: {
    displayName: "Parenting and Children's Health",
    value: 'parentingChildrensHealth',
  },
  pregnancyBabyBulletin: {
    displayName: 'Pregnancy & Baby Bulletin',
    value: 'pregnancyBabyBulletin',
  },
  psoriasis: {
    displayName: 'Psoriasis',
    value: 'psoriasis',
  },
  rheumatoidArthritis: {
    displayName: 'Rheumatoid Arthritis',
    value: 'rheumatoidArthritis',
  },
  studiesShow: {
    displayName: 'Studies Show',
    value: 'studiesShow',
  },
  supportAdvancedBreastCancer: {
    displayName: 'Support for Advanced Breast Cancer',
    value: 'supportAdvancedBreastCancer',
  },
  womensHealth: {
    displayName: "Women's Health",
    value: 'womensHealth',
  },
};

export const Z_INDEX_MAX = 2147483647;
